import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Standard Firebase config loaded from environment variables.
// If these are not configured, we'll use placeholder/mock values so the app doesn't crash.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "placeholder-api-key",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "placeholder-auth-domain.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "placeholder-project-id",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "placeholder-storage-bucket.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "placeholder-sender-id",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "placeholder-app-id"
};

// Check if we are running in mock mode (i.e. no real credentials supplied or placeholder values are present)
export const isFirebaseMock = 
  !process.env.REACT_APP_FIREBASE_API_KEY || 
  process.env.REACT_APP_FIREBASE_API_KEY === "placeholder-api-key" ||
  process.env.REACT_APP_FIREBASE_API_KEY.startsWith("your_") ||
  process.env.REACT_APP_FIREBASE_API_KEY.includes("placeholder");

let app;
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };
